export default __webpack_public_path__ + "static/media/MG2.016a1347.png";